import React from "react";

const CartItems = ({
  cartItems,
  handleQuantityChange,
  removeFromCart,
  totalPrice,
  shippingRate,
}) => {
  return (
    <div className="col-md-12">
      <div className="cart-items">
        <ul className="list-group mb-4 checkoutCard rounded-0">
          {cartItems.map((item, index) => {
            const { selectedProduct, selectedSize, quantity } = item;
            const { prices, name, images } = selectedProduct;

            // Find the price object matching the selected size
            const priceObj = prices.find(
              (price) => price.size === selectedSize
            );

            // Handle the case where the price is not found
            const price = priceObj ? priceObj.amount : 0;
            return (
              <li
                key={index}
                className="list-group-item d-flex flex-wrap justify-content-between align-items-center border-0 checkoutCard rounded-0"
              >
                <div className="d-flex align-items-center w-100">
                  {/* Product Image */}
                  <img
                    src={images[0]}
                    alt={name}
                    className="img-thumbnail me-3"
                    style={{
                      width: "80px",
                      objectFit: "cover",
                    }}
                  />

                  {/* Product Details */}
                  <div className="w-100">
                    {/* Product Name and Price */}
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-2">
                      <h5 className="mb-1">
                        <strong className="text-lowercase">{name}</strong>{" "}
                        <small className="text-capitalize">
                          - {selectedSize}
                        </small>
                      </h5>
                      <strong className="mb-1">£{price.toFixed(2)}</strong>
                    </div>

                    {/* Quantity and Remove Button */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                      {/* Quantity Controls */}
                      <p className="mb-2 mb-md-0">
                        <small>
                          quantity:
                          <button
                            className="border-0 text-primary-color bg-transparent fw-bold mx-1"
                            onClick={() => handleQuantityChange(item, -1)}
                            disabled={item.quantity <= 1}
                          >
                            -
                          </button>
                          <span className="quantity-value">{quantity}</span>
                          <button
                            className="border-0 text-primary-color bg-transparent fw-bold mx-1"
                            onClick={() => handleQuantityChange(item, 1)}
                          >
                            +
                          </button>
                        </small>
                      </p>

                      {/* Remove Button */}
                      <button
                        className="removeBtn"
                        onClick={() => removeFromCart(item)}
                      >
                        <small>Remove</small>
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}

          <div className="px-3">
            <div className="checkoutTotalRow">
              <p className="mb-1 text-capitalize">Subtotal:</p>
              <p className="mb-1 ">£{totalPrice.toFixed(2)}</p>
            </div>
            <div className="checkoutTotalRow">
              <div className="mb-2">
                <p className="mb-0 text-capitalize">Postage:</p>
                <small className="text-primary-color text-capitalize">
                  {shippingRate ? shippingRate.description : ""}
                </small>
              </div>

              <p className={`${shippingRate ? "" : "text-grey"}`}>
                {shippingRate
                  ? `£${shippingRate.amount.toFixed(2)}`
                  : "(To be calculated)"}
              </p>
            </div>

            <div className="checkoutTotalRow  border-top py-2">
              <strong className="text-capitalize">Total:</strong>
              <strong className="">
                £{(totalPrice + (shippingRate?.amount || 0)).toFixed(2)}
              </strong>
            </div>
            <p className="text-center text-capitalize paymentSecuredText">
              Payment secured by Stripe
            </p>
          </div>
        </ul>
        <a
          className="w-100 emailLink"
          href="mailto:contact@tailoredstories.co.uk"
        >
          email:
          <span className="orangeText mx-1">contact@tailoredstories.co.uk</span>
        </a>
      </div>
    </div>
  );
};

export default CartItems;
